module.exports = __webpack_public_path__ + "img/help5.a3dc6c40.png";